<template lang="html">
  <span>{{ decimals ? format(tweeningValue.toFixed(decimals)) : format(tweeningValue) }}</span>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    value: {
      type: Number,
      required: true
    },
    decimals: Number,
    timing: {
      type: Number,
      default: 500,
      validator (v) {
        return Number(v) > 0
      }
    },
    format: {
      type: Function,
      default: v => v
    }
  },
  data () {
    return {
      tweeningValue: 0,
      timeout: null
    }
  },
  watch: {
    value (v, ov) {
      v = isNaN(v) ? 0 : v
      ov = isNaN(ov) ? 0 : ov
      if (v < ov) {
        ov = 0
        this.tweeningValue = 0
      }
      this.tweenNumber(v, ov)
    }
  },
  mounted () {
    this.tweenNumber(this.value, 0)
  },
  methods: {
    tweenNumber (toValue, fromValue, interval = 20) {
      if (this.timeout) clearTimeout(this.timeout)

      if (!fromValue) fromValue = this.tweeningValue || 0

      var iterations = Number(this.timing) / interval
      var iterator = (toValue - fromValue) / iterations

      const tween = () => {
        if (this.tweeningValue < toValue) {
          this.timeout = setTimeout(() => {
            var currentValue = this.tweeningValue
            if (currentValue + iterator > toValue) {
              this.tweeningValue = toValue
            } else {
              this.tweeningValue = currentValue + iterator
            }
            tween()
          }, interval)
        }
      }
      tween()
    }
  }

}
</script>

<style lang="css" scoped>

</style>
